module.exports = __webpack_public_path__ + "static/media/tree_589kb.5f142078.png";